import React from 'react';
import './SelectableBoxGrid.scss';

export interface SelectableBoxOption {
  id: string;
  label: string;
  icon?: React.ReactNode;
  iconColor?: string;
  iconSize?: number;
  disabled?: boolean;
  disabledInfo?: string;
}

interface SelectableBoxGridProps {
  options: SelectableBoxOption[];
  value: string | null;
  onChange: (id: string) => void;
  isSelectable?: boolean;
}

export const SelectableBoxGrid: React.FC<SelectableBoxGridProps> = ({
  options,
  value,
  onChange,
  isSelectable = true,
}) => {
  return (
    <div className="selectable-box-grid">
      {options.map((option) => (
        <div
          key={option.id}
          className={`selectable-box ${value === option.id ? 'selectable-box--selected' : ''} ${option.disabled ? 'selectable-box--disabled' : ''} ${!isSelectable ? 'selectable-box--readonly' : ''}`}
          style={option.iconColor ? { '--box-accent-color': option.iconColor } as React.CSSProperties : undefined}
          onClick={() => isSelectable && !option.disabled && onChange(value === option.id ? '' : option.id)}
          data-tooltip-id={option.disabled && option.disabledInfo ? 'main-tooltip' : undefined}
          data-tooltip-content={option.disabled && option.disabledInfo ? option.disabledInfo : undefined}
        >
          {option.icon && <span className="selectable-box__icon" style={{ fontSize: option.iconSize }}>{option.icon}</span>}
          <span className="selectable-box__label">{option.label}</span>
        </div>
      ))}
    </div>
  );
};
